
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Star, ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';

const MembershipCTA = () => {
  return (
    <Card className="border-juv-terracotta/30 bg-gradient-to-r from-juv-soft-blush to-white">
      <CardHeader>
        <CardTitle className="flex items-center space-x-2 text-juv-terracotta">
          <Star className="h-5 w-5" />
          <span>Unlock Member Savings</span>
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="text-juv-deep-chestnut">
          <p className="text-sm mb-2">Save up to 40% on all treatments</p>
          <ul className="text-xs space-y-1 text-juv-deep-chestnut/70">
            <li>• Exclusive member pricing</li>
            <li>• Priority booking</li>
            <li>• Bonus credit rewards</li>
          </ul>
        </div>
        <Button 
          asChild 
          className="w-full bg-juv-terracotta hover:bg-juv-deep-chestnut"
        >
          <Link to="/membership">
            Learn About Membership
            <ArrowRight className="h-4 w-4 ml-2" />
          </Link>
        </Button>
      </CardContent>
    </Card>
  );
};

export default MembershipCTA;
